if (document.querySelector('.open_filter_cls')) {
  document.querySelector('.open_filter_cls').addEventListener('click', function() {
    this.classList.toggle('filter_active');
    document.getElementById('FacetsWrapperDesktop').classList.toggle('dd_cm_filter');
    document.querySelector('[aria-labelledby="verticalTitle"]').classList.toggle('dd_filter');
    document.querySelector('[collection-grid-class]').classList.toggle('custom_grid_class');
    if (document.querySelector('[collection-grid-class]').classList.contains('grid--4-col-desktop')) {
      document.querySelector('[collection-grid-class]').classList.remove('grid--4-col-desktop')
      document.querySelector('[collection-grid-class]').classList.add('grid--3-col-desktop');
    } else if (document.querySelector('[collection-grid-class]').classList.contains('grid--3-col-desktop')) {
      document.querySelector('[collection-grid-class]').classList.remove('grid--3-col-desktop')
      document.querySelector('[collection-grid-class]').classList.add('grid--4-col-desktop');
    }
  });
}

/*==== menu hover Js ======*/


if (window.innerWidth >= 1440) {
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      // var isAttr = item.getAttribute('custom_mega_menu');
      // if (!isAttr) {
      //   headerSelector.classList.add('men-bg-menu');
      //   document.body.classList.add('men-bg-menu-color');
      // }
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        // if (headerSelector.classList.contains('men-bg-menu')) {
        //   headerSelector.classList.remove('men-bg-menu');
        // }
      });
    });
  });

  var headerSelector = document.querySelector('sticky-header');
  let items_menu = document.querySelector(".header__inline-menu").querySelectorAll("li");
    items_menu.forEach(item => {
    item.addEventListener("mouseover", () => {
      var isAttr = item.getAttribute('custom_mega_menu');
      if (document.body.classList.contains('men-bg-menu-color')) {
        if (isAttr == 'false') {
          headerSelector.classList.add('men-bg-menu');
        }
      }else{
        if (isAttr == 'true') {
          headerSelector.classList.add('men-bg-menu');          
        }
      }
      item.addEventListener("mouseleave", () => {
        if (headerSelector.classList.contains('men-bg-menu')) {
          headerSelector.classList.remove('men-bg-menu');
        }
      });
    });
  });  
}

/*====menu hover Js======*/

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();

})();


// hotsport start
function hosport_click(item) {
  item.addEventListener("click", (event) => {
    event.stopPropagation(); // Prevent body click event from firing immediately
    
    let hide_content = document.querySelectorAll("[data-host-port-content]");
    let targetSelector = event.target.getAttribute('data-hotsport-click');
    let targetContent = document.querySelector(targetSelector);

    if (targetContent) {
      if (targetContent.classList.contains('hidden')) {
        // Hide all other content
        hide_content.forEach(b => b.classList.add("hidden"));
        
        // Show the clicked content
        targetContent.classList.remove("hidden");
        targetContent.classList.add("show_spot");
        document.body.classList.add('overflow_hidden');
      } else {
        // Hide current content
        targetContent.classList.add("hidden");
        targetContent.classList.remove("show_spot");
        document.body.classList.remove('overflow_hidden');
      }
    }
  });
}

// Attach event to all elements with [data-hotsport-click]
document.querySelectorAll("[data-hotsport-click]").forEach(hosport_click);

// Body click to close content when clicking outside
document.body.addEventListener("click", (event) => {
  if (document.body.classList.contains("overflow_hidden")) {
    // Ignore clicks inside the currently open content
    if (!event.target.closest('.show_spot[data-host-port-content]')) {
      console.log("Closing content");

      document.querySelector('.show_spot[data-host-port-content]')?.classList.add("hidden");
      document.querySelector('.show_spot[data-host-port-content]')?.classList.remove("show_spot");
      document.body.classList.remove('overflow_hidden');
    }
  }
});


// hotsport end


//megamenu hover
// document.querySelectorAll('.custom_main_link').forEach(function(link) {
//   link.addEventListener('mouseenter', function() {
//     var dataTitle = this.getAttribute('data_title');
//     var parent = this.closest('.custom_mega_menu_header');
//     document.querySelectorAll('.custom_main_link').forEach(function(link) {
//         link.classList.remove('active');
//     });
//     this.classList.add('active');
//     document.querySelectorAll('.custom_mega-penal').forEach(function(panel) {
//         panel.classList.add('hidden');
//     });
//     if (document.querySelector('.custom_mega-penal.hidden[data_title="' + dataTitle + '"]')) {
//       document.querySelectorAll('.custom_mega-penal[data_title="' + dataTitle + '"]').forEach(function(item) {
//         item.classList.remove('hidden');
//       });
//     }
//   });
// });


document.querySelectorAll('.custom_main_link').forEach(function(link) {
  link.addEventListener('mouseenter', function() {
    var dataTitle = this.getAttribute('data_title');
    var parent = this.closest('.custom_mega_menu_header');

    // Remove active from links inside this header only
    parent.querySelectorAll('.custom_main_link').forEach(function(innerLink) {
      innerLink.classList.remove('active');
    });
    this.classList.add('active');

    // Hide all panels inside this header
    parent.querySelectorAll('.custom_mega-penal').forEach(function(panel) {
      panel.classList.add('hidden');
    });

    // Show matching panel inside this header
    parent.querySelectorAll('.custom_mega-penal[data_title="' + dataTitle + '"]').forEach(function(item) {
      item.classList.remove('hidden');
    });
  });
});


// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

 // <show-password>
 //   <a href="javascript:void(0);"class="close-icon">text</a>
 // </show-password>

customElements.define('show-password', ShowPassword);

// PASSWORD SHOW AND HIDE END

// Blog Page Tag Filter Button Slider JS
let articleSwiper = null;

function initArticleSwiper() {
  if (window.innerWidth < 750 && !articleSwiper) {
    articleSwiper = new Swiper('.cm_mobile_blog_slider', {
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: { slidesPerView: 2 },
        450: { slidesPerView: 2 },
        749: { slidesPerView: 3 }
      }
    });
  } else if (window.innerWidth >= 750 && articleSwiper) {
    articleSwiper.destroy(true, true);
    articleSwiper = null;
  }
}

// Run on load
initArticleSwiper();

// Run on resize
window.addEventListener('resize', () => {
  initArticleSwiper();
});

// Book appointment page
if (document.body.classList.contains('template-termin-buchen')) {
  const book_appoint_buttons = document.querySelectorAll('[book_appoint_button]');
  if (book_appoint_buttons.length > 0) {
     book_appoint_buttons.forEach(button => {
      const step_number = button.getAttribute('data-step_number');
      const type_data = button.getAttribute('data-type_data');
       button.addEventListener("click", () => {
         console.log("type_data",type_data)
         console.log("step_number" , step_number)
         document.querySelectorAll('[appointment_page]').forEach(item => {
           item.classList.add('hidden');
         });
         const showDivs = document.querySelectorAll('[data-step_number="'+ step_number +'"][data-type_data="'+ type_data +'"]');
         console.log("showDivs",showDivs)
         window.scrollTo({ top: 0, behavior: 'smooth' });
         showDivs.forEach(div => {
           div.classList.remove('hidden');
         });
       });
    }); 
  }

 const book_appoint_buttons_new = document.querySelectorAll('[book_appoint_button_new]');

if (book_appoint_buttons_new.length > 0) {
  book_appoint_buttons_new.forEach(button => {
    button.addEventListener("click", event => {
      event.preventDefault();
      const targetLink = document.querySelector("[book_appoint_button_trigger]");
      if (targetLink) targetLink.click();
    });
  });
}


   const book_appoint_button_new_new = document.querySelectorAll('[book_appoint_button_new_new]') || null;
  if (book_appoint_button_new_new.length > 0) {
         book_appoint_button_new_new.forEach(button => {
        button.addEventListener("click", (event) => {
             event.preventDefault();
          document.querySelector("[book_appoint_button_trigger_new]").click();
       });
        }); 
   }   

}


function popup_open() {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'VL4wyK']);

}

document.querySelectorAll('[data-klaviyopopup-open]').forEach((el) => {
  el.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    popup_open(); // Call your function
  });
});


//  timer workshop

  // function updateCountdown() {
  //   // Example end date - update as per your requirement
  //   const endDate = new Date("2025-12-31T23:59:59").getTime();

  //   const now = new Date().getTime();
  //   const distance = endDate - now;

  //   if (distance < 0) {
  //     // Timer ended
  //     return;
  //   }

  //   const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0');
  //   const hours = String(Math.floor((distance / (1000 * 60 * 60)) % 24)).padStart(2, '0');
  //   const minutes = String(Math.floor((distance / (1000 * 60)) % 60)).padStart(2, '0');
  //   const seconds = String(Math.floor((distance / 1000) % 60)).padStart(2, '0');

  //   // Helper function to render each digit in its own span
  //   function renderDigits(containerId, value) {
  //     const container = document.getElementById(containerId);
  //     if (container){

  //       container.innerHTML = '';
  //       for (let digit of value) {
  //         const span = document.createElement('span');
  //         span.textContent = digit;
  //         container.appendChild(span);
  //       }
  //     }
  //   }

  //   renderDigits('days', days);
  //   renderDigits('hours', hours);
  //   renderDigits('minutes', minutes);
  //   renderDigits('seconds', seconds);
  // }

  // Initial call
  // updateCountdown();

  // // Update every second
  // setInterval(updateCountdown, 1000);


  function updateCountdown() {
  const countdownEl = document.getElementById("countdown");
  if (!countdownEl) return;

  const startDateAttr = countdownEl.getAttribute("data-start-date");
  const endDateAttr = countdownEl.getAttribute("data-end-date");

  const now_timesta = Date.now();

  if (!endDateAttr) return;

  // Parse "dd-mm-yyyy" into a fixed date without timezone shift
  function parseDate(dateStr) {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('-').map(Number);
    // Create UTC date (avoid timezone offset issues)
    return new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
  }

  const startDate = parseDate(startDateAttr);
  const endDate = parseDate(endDateAttr);
  const now = new Date();
    const now_sart = Date.now();

  console.log(now_timesta,now_sart)

  // Convert current time to UTC to compare properly
  const nowUTC = new Date(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds()
  );

  // If countdown hasn't started yet
  if (startDate && nowUTC < startDate) {
    document.getElementById("days").textContent = "00";
    document.getElementById("hours").textContent = "00";
    document.getElementById("minutes").textContent = "00";
    document.getElementById("seconds").textContent = "00";
    return;
  }

  const distance = endDate - nowUTC;

  if (distance <= 0) {
    // Countdown ended
    document.getElementById("days").textContent = "00";
    document.getElementById("hours").textContent = "00";
    document.getElementById("minutes").textContent = "00";
    document.getElementById("seconds").textContent = "00";
    return;
  }

  const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0');
  const hours = String(Math.floor((distance / (1000 * 60 * 60)) % 24)).padStart(2, '0');
  const minutes = String(Math.floor((distance / (1000 * 60)) % 60)).padStart(2, '0');
  const seconds = String(Math.floor((distance / 1000) % 60)).padStart(2, '0');

  // Render each digit separately
  function renderDigits(containerId, value) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = '';
    for (let digit of value) {
      const span = document.createElement('span');
      span.textContent = digit;
      container.appendChild(span);
    }
  }

  renderDigits('days', days);
  renderDigits('hours', hours);
  renderDigits('minutes', minutes);
  renderDigits('seconds', seconds);
}

setInterval(updateCountdown, 1000);
updateCountdown();



   const form = document.getElementById('locksmith_form');
  if (form){
  const input = document.getElementById('locksmith_passcode');
  const error = document.getElementById('error_message');

  form.addEventListener('submit', function(e) {
    e.preventDefault(); // stop default form behavior

    const passcode = input.value.trim();
    error.style.display = 'none';
    error.textContent = '';

    if (passcode == 'HEIMATSECRET') {
      Locksmith.submitPasscode("HEIMATSECRET");
      window.location.href = '/collections/secret-sale?check_password';
    } else {
      error.textContent = 'Falsches Passwort. Bitte versuche es erneut.';
      error.style.display = 'block';
    }
  });
}